import { Box, Typography } from '@mui/material'
import CustomOption2 from '../components/CustomOption2'
import CustomCheckbox from '../components/Inputs/CustomCheckbox'
const Noise = () => {
  return (
    <Box sx={{ padding: '20px 0px 40px 0px' }}>
      <Typography className="general-text-light" sx={{ mb: 6 }}>
        <span className="general-text">Task Name - </span>Noise
      </Typography>
      <Typography className="general-text">Hazardous Elements</Typography>
      <CustomCheckbox
        label="Plant and Equipment"
        name="Plant_and_Equipment"
        component={
          <Box>
            <CustomOption2
              label="Exposure to noise - "
              name="Exposure_to_noise"
              warning={true}
              sliderDescription="Use of hearing protection when operating noisy plant and equipment - inline with manufacturers recommendations ."
            />
          </Box>
        }
        conditional_heading="Plant and Equipment"
      />
    </Box>
  )
}

export default Noise
